import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSquare, FiCheckSquare, FiTrash2 } = FiIcons;

function DailyNotesSection({ notes, addNote, updateNote, deleteNote }) {
  const [noteText, setNoteText] = useState('');

  const handleAddNote = async () => {
    if (noteText.trim() === '') return;
    try {
      await addNote(noteText);
      setNoteText('');
    } catch (error) {
      console.error('Error adding note:', error);
    }
  };

  const handleToggleNote = async (id) => {
    const note = notes.find(n => n.id === id);
    if (note) {
      try {
        await updateNote(id, { completed: !note.completed });
      } catch (error) {
        console.error('Error updating note:', error);
      }
    }
  };

  const handleDeleteNote = async (id) => {
    try {
      await deleteNote(id);
    } catch (error) {
      console.error('Error deleting note:', error);
    }
  };

  return (
    <div className="mt-8 p-8 bg-white rounded-3xl shadow-xl border border-gray-100">
      <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-6">
        Note Giornaliere
      </h2>
      
      <div className="mb-6">
        <textarea
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          placeholder="Aggiungi una nuova nota per oggi..."
          className="w-full h-32 p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200 text-lg"
        />
        <button
          onClick={handleAddNote}
          className="mt-4 p-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 w-full"
        >
          Salva Nota
        </button>
      </div>

      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-xl font-bold text-gray-700 mb-4">Note Salvate</h3>
        <div>
          {notes.length === 0 ? (
            <p className="text-gray-500 italic text-lg">Nessuna nota salvata per oggi.</p>
          ) : (
            <ul className="space-y-4">
              {notes.map(note => (
                <li key={note.id} className="flex items-start p-6 bg-gradient-to-r from-gray-50 to-white rounded-3xl shadow-lg border border-gray-100">
                  <button
                    onClick={() => handleToggleNote(note.id)}
                    className="mt-1 text-gray-400 hover:text-green-500 transition-colors duration-200 focus:outline-none p-2 rounded-xl hover:bg-green-50"
                  >
                    <SafeIcon 
                      icon={note.completed ? FiCheckSquare : FiSquare} 
                      className={`text-xl ${note.completed ? 'text-green-500' : ''}`} 
                    />
                  </button>
                  <div className="ml-4 flex-1">
                    <p className={`text-gray-800 text-lg font-medium ${note.completed ? 'line-through text-gray-500' : ''}`}>
                      {note.text}
                    </p>
                    <p className="text-sm text-gray-400 mt-2">
                      {new Date(note.created_at).toLocaleString('it-IT')}
                    </p>
                  </div>
                  <button
                    onClick={() => handleDeleteNote(note.id)}
                    className="mt-1 text-gray-400 hover:text-red-500 transition-colors duration-200 focus:outline-none p-2 rounded-xl hover:bg-red-50"
                  >
                    <SafeIcon icon={FiTrash2} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default DailyNotesSection;